export enum Jurisdiction {
  COM = 'com',
  ES = 'es',
  IT = 'it',
}
